import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ModalThankLowGrant from "./Modal/ModalThankLowGrant.jsx";
import useStore from "../store.js";
import { trackNaverPurchase } from "../utils/naverConversion.js";
import { waitForCreditCharge } from "../utils/paymentConfirmation.js";
import {
  clearPendingWebPayment,
  loadPendingWebPayment,
  parsePaymentRedirectResult,
  stripPaymentRedirectParams,
} from "../utils/paymentRedirect.js";

// 모바일 웹 결제 후 PG가 결제를 시작한 화면으로 리다이렉트하면
// URL의 결제 결과 파라미터를 한 번만 처리하고 원래 화면 위에 결과를 보여준다.
const PaymentRedirectHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { updateUserInfo } = useStore();
  const handledRef = useRef(false);
  const [purchasedLowCount, setPurchasedLowCount] = useState(0);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);

  useEffect(() => {
    if (handledRef.current) return;

    const result = parsePaymentRedirectResult(location.search);
    if (!result) return;

    handledRef.current = true;

    const pendingPayment = loadPendingWebPayment();
    clearPendingWebPayment();

    // 새로고침해도 같은 결제 결과를 다시 처리하지 않도록 파라미터를 제거한다.
    navigate(
      `${location.pathname}${stripPaymentRedirectParams(location.search)}`,
      { replace: true }
    );

    if (!result.isSuccess) {
      if (result.errorMsg) {
        alert(`결제에 실패하였습니다. 에러 내용: ${result.errorMsg}`);
      }
      return;
    }

    const lowCount = Number(pendingPayment?.lowCount) || 0;
    setPurchasedLowCount(lowCount);
    setShowSuccessModal(true);
    setIsConfirming(true);

    const confirmPurchase = async () => {
      try {
        const isCreditConfirmed = await waitForCreditCharge({
          creditBefore: pendingPayment?.creditBefore,
          lowCount,
        });

        const merchantUid = result.merchantUid || pendingPayment?.id;
        if (isCreditConfirmed && pendingPayment?.value && merchantUid) {
          await trackNaverPurchase({
            value: pendingPayment.value,
            id: merchantUid,
          });
        }
      } catch (error) {
        console.error("리다이렉트 결제 확인 중 오류가 발생했습니다.", error);
      } finally {
        await updateUserInfo(() => {});
        setIsConfirming(false);
      }
    };

    confirmPurchase();
  }, [location, navigate, updateUserInfo]);

  if (!showSuccessModal) return null;

  return (
    <ModalThankLowGrant
      isOpen={showSuccessModal}
      onConfirm={() => setShowSuccessModal(false)}
      messageTitle="로우 결제가 완료되었습니다!"
      messageSubtitle={
        isConfirming
          ? `${purchasedLowCount ? `${purchasedLowCount}로우 ` : "로우 "}충전을 확인하고 있습니다.`
          : `${purchasedLowCount ? `${purchasedLowCount}로우가` : "로우가"} 충전되었습니다.`
      }
      confirmText={isConfirming ? "확인 중" : "확인"}
      isConfirmDisabled={isConfirming}
    />
  );
};

export default PaymentRedirectHandler;
